
import { Component, Vue, Prop } from 'vue-property-decorator';
import commonService from '@/services/common-services';
import { APP_CONFIG } from '@/config/app-config';
import { DATA } from '@/config/data';

@Component
export default class DeliveryInfo extends Vue {
    @Prop({default: null})
    private customer: any;
    zeroPad = (num, places) => String(num).padStart(places, '0');
    get warehouse() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].warehouse;
    }

    get chinaStore() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].chinaStore;
    }

    private async getWarehouse() {
        const result = await commonService.getWarehouse();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_WAREHOUSE', result.data.data);
        }
    }

    private async getChinaStore() {
        const result = await commonService.getChinaStore();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_CHINASTORE', result.data.data);
        }
    }

    get chinaStoreAddress() {
        if (this.customer && this.customer.ChinaStoreID && this.chinaStore) {
            const result = this.chinaStore.find(c => c.ID == this.customer.ChinaStoreID);

            if (result) {
               return `${this.customer.UserCode} - ${result.Phone} - ${result.Address}`;
            }
        }
        return '';
    }

    // get chinaStoreDescription() {
    //     if (this.customer && this.customer.ChinaStoreID && this.chinaStore) {
    //         const result = this.chinaStore.find(c => c.ID == this.customer.ChinaStoreID);

    //         if (result) {
    //            return result.Description && result.Description != '' ? JSON.parse(result.Description) : null;
    //         }
    //     }
    //     return null;
    // }

    private async created() {
        if (!this.warehouse) {
            await this.getWarehouse();
        }
        if (!this.chinaStore) {
            await this.getChinaStore();
        }
    }
}
